import * as React from 'react';
import SummaryCard from 'nomst/Components/SharedJobCollab/summaryCard';
import {
    buildFullName,
    extractInitials } from 'utils/jobCollabEmployeeUtils';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';
import './employeeCard.scss';

interface EmployeeCardProps {
    firstName?: string;
    lastName?: string;
    detail?: string;
    gender?: string;
    id: string;
    className?: string;
}

const EmployeeCard = (props: EmployeeCardProps): JSX.Element => {
    const { id,
        firstName,
        lastName,
        detail,
        className } = props;

    const onClickHandler = (): void => {
        navigateToNoMst.navigateToEmployeeDetails(id);
    };
    
    return (
        <SummaryCard
            id={id}
            className={`employee-card ${className || ''}`}
            heading={buildFullName(firstName, lastName)}
            subHeading={detail}
            circleDisplay={extractInitials(firstName, lastName)}
            onClickHandler={onClickHandler}
        />
    );
};

export { EmployeeCard };
export default EmployeeCard;